import useAct from 'FlowOverview/useAct'
import Stat from 'Shared/components/Stat'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import ActionHeader from './ActionHeader'
import useActionLabel from '../../useActionLabel'
import './ActionStats.scoped.scss'

export default function EmailToTarget({ flowId, actionId, removed }) {
  const act = useAct()
  const { stats, actions } = useSel((s) => s.flow)
  const action = actions?.find(a => a.id === actionId)
  const [searchTerm, setSearchTerm] = useState('')
  const label = useActionLabel('email_to_target')

  useEffect(() => {
    if (flowId) {
      act.flow.load(flowId)
      act.flow.loadStats(flowId)
    }
  }, [flowId])

  if (!action || !stats) {
    return <div>Loading...</div>
  }

  let actionStats = {}
  let statConfigs = []
  let filteredDecisionMakersData = []
  let decisionMakersData = []
  let chartHeight = 0

  if (action.kind === 'email_to_target' && stats.steps) {
    const stepStats = stats.steps.find(step => step.kind === 'email_to_target')
    if (stepStats) {
      actionStats = {
        emailsSent: stepStats.emailsSent || 0,
        recipientsCount: stepStats.recipientsCount || 0,
        emailsOpened: stepStats.emailsOpened || 0
      }
      statConfigs = [
        { label: 'Emails sent', key: 'emailsSent' },
        { label: 'People emailed', key: 'recipientsCount' },
        { label: 'Emails opened', key: 'emailsOpened' }
      ]

      if (stepStats.decisionMakers && stepStats.decisionMakers.length > 0) {
        decisionMakersData = stepStats.decisionMakers.slice(0, 25).map(dm => ({
          name: dm.name,
          emailsSent: dm.emailsSent - dm.emailsOpened,
          emailsOpened: dm.emailsOpened
        }))

        filteredDecisionMakersData = decisionMakersData.filter(dm =>
          dm.name.toLowerCase().includes(searchTerm.toLowerCase())
        )

        chartHeight = filteredDecisionMakersData.length * 50 + 50
      }
    }
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }

  return (
    <div className="flow-action-stats">
      <div className='box margin-top double' id='email_to_target'>
        <ActionHeader flowId={flowId} actionId={actionId} title={`${label}${removed ? ' (removed)' : ''}`} />
        <div className='stats'>
          {statConfigs.map(({ label, key }) => (
            <div className='item' key={key}>
              <Stat
                borderBottom={false}
                size={'vertical'}
                label={label}
                primary={actionStats[key]}
              />
            </div>
          ))}
        </div>
        {decisionMakersData.length > 0 && <>
          <h2 className="no-margin-top">Recipients</h2>
          <div className="filter">
            <SvgIconsSearch className="icon" />
            <input
              type="text"
              placeholder="Search by recipient name"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <div className="chart-container" style={{ height: chartHeight }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={filteredDecisionMakersData}
                layout="vertical"
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <XAxis type="number" />
                <YAxis type="category" dataKey="name" width={120} interval={0} reversed={true} />
                <Tooltip />
                <Bar dataKey="emailsSent" fill="#8884d8" name="Emails Sent" stackId="a" />
                <Bar dataKey="emailsOpened" fill="#82ca9d" name="Emails Opened" stackId="a" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>}
      </div>
    </div>
  )
}
